import { cleengLogout } from '../index';

export const cleengSignOut = () => {
    cleengLogout();
};
